export default __webpack_public_path__ + "static/media/project4.8bec7047.png";